module.exports = __webpack_public_path__ + "img/vue.c1733376.svg";